import React from "react"
import { useSelector } from "react-redux"
import { hasUnread } from "reduxSlices/featureAnnouncementSlice"
import { BellIcon, IndicatorIcon } from "shared/icons"
import IconTapTarget from "shared/IconTapTarget"

const PanelTrigger = () => {
  const unread = useSelector(hasUnread)

  return (
    <IconTapTarget className="flex justify-center items-center relative" label={`feature announcements${unread ? ". contains unread" : ""}`}>
      <BellIcon className="cursor-pointer" ariaHidden />
      {
        unread && (
          <IndicatorIcon className="absolute top-[1.125rem] right-3 cursor-pointer" ariaHidden />
        )
      }
    </IconTapTarget>
  )
}

export default PanelTrigger
